const { createSlice } = require("@reduxjs/toolkit");

const initialState = {
    sort: '',
    isSaved: false,
};

const sortFilterSlice = createSlice({
    name: "sortFilter",
    initialState,
    reducers: {
        sortSelected: (state, action) => {
            state.sort = action.payload;
        },
        filterToggled: (state, action) => {
            state.isSaved = action.payload;
        }
    },
});

export default sortFilterSlice.reducer;
export const { sortSelected, filterToggled } = sortFilterSlice.actions;
